import { Component, Input, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { WebhookStagingStore } from "@app/services/store/webhook-staging-store";
import { WebhookDefinitionStore } from "@app/services/store/webhook-definition-store";
import { WebhookDefinition } from "@app/models/rest/webhook-definition";
import { WebhookStaging } from "@app/models/rest/webhook-staging";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-webhook-log",
  templateUrl: "./webhook-log.component.html",
  styleUrls: ["./webhook-log.component.css"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class WebhookLogComponent
  extends BaseDataTablePageDirective<WebhookStaging>
  implements OnInit
{
  webhookStore = inject(WebhookDefinitionStore);
  webhookStagingStore: WebhookStagingStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;
  private activeRoute = inject(ActivatedRoute);

  public id: number;
  public webhook: WebhookDefinition;
  @Input()
  public columns: object[] = [
    {
      field: "creationDate",
      text: "Date",
      width: 150,
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      editor: false
    },
    {
      text: "Body",
      editor: false,
      field: "requestBody",
      flex: 1,
      htmlEncode: false,
      renderer(data) {
        const { value } = data;
        return `<webhook-request-display requestbodyjson='${value}'></webhook-request-display>`;
      },
      autoHeight: true
    },
    {
      field: "status",
      text: "Status",
      width: 100,
      editor: false
    },
    {
      field: "retries",
      text: "Retry #",
      width: 60,
      editor: false
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const webhookStagingStore = inject(WebhookStagingStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      webhookStagingStore,
      store,
      dialog,
      "WebhookStaging",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );
    this.webhookStagingStore = webhookStagingStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;

    this.activeRoute.params.subscribe((params) => {
      this.id = params["id"];
      console.log(params["id"]);
      this.webhookStore.loadSingle(this.id).then((value) => {
        this.webhook = value;

        this.gridStore.parentField = "destination.id";
        this.gridStore.parentId = this.webhook.id;
        this.gridStore.autoCommit = false;
        this.gridStore.sort("creationDate", false);
        this.gridStore.autoCommit = false;
        this.gridStore.load({});
      });
    });
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
